import { useEffect, useState } from "react";
import CustomButton from "../../components/CustomButton";
import "../../assets/css/ApproveOrDenyRequest.css";
import "../../assets/css/Custom.css";
import ballImage from "../../assets/images/ballImage.png";
import participantImage from "../../assets/images/participantImage.png";
import { MdPeopleOutline } from "react-icons/md";
import { CiLocationArrow1, CiCalendarDate } from "react-icons/ci";
import { FaDollarSign } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import { useSelector } from "react-redux";
import GoogleMapComponent from "../../components/GoogleMap";
import { toast } from "react-toastify";
import { RxCross2 } from "react-icons/rx";
import PaymentModal from "../../components/PaymentModal";
import { HashLoader } from "react-spinners";
import { IoIosArrowDropleft } from "react-icons/io";
import LeaveGameModal from "../../components/LeaveGame";
import Boy from '../../assets/icons/B.png';
import Girl from '../../assets/icons/G.png';
import { useLocation } from "react-router-dom";


const GameDetails = () => {
  const navigate = useNavigate();
  const { gameId } = useParams();
  const { accessToken, saveCardDetailData, userId, profileData } = useSelector((state) => state.loginInfo);
  const [isOpen, setIsOpen] = useState(false);
  const [gameDetails, setGameDetails] = useState(null);
  const [courtData, setCourtData] = useState([{}]);
  const [formData, setFormData] = useState();
  const [errors, setErrors] = useState();
  const [selectedGameId, setSelectedGameId] = useState();
  const [leaveGame, setLeaveGame] = useState(false);
  const [isModalVisible, setModalVisible] = useState(true);
  const [isOpenModalLeaveGame, setIsOpenModalLeaveGame] = useState();
  const location = useLocation();
  const { result, keyId } = location.state || {};
  console.log('userInfo ', profileData.baseProfile.avatarName)

  useEffect(() => {
    const fetchGames = async () => {
      const result = await apiHandler({
        url: `${endpoint.GAME_DETAIL}?gameId=${gameId}`,
        method: "GET",
        authToken: accessToken?.accessToken,
      });
      setGameDetails(result.data);
      setCourtData([{ longitude: result.data.coordinates.longitude, latitude: result.data.coordinates.latitude, courtName: result.data.courtName }])
    };
    fetchGames();
  }, [gameId, accessToken]);

  useEffect(() => {
    const fetchGames = async () => {
      const result = await apiHandler({
        url: `${endpoint.MARK_SEEN}`,
        method: "POST",
        data: { notificationIds: [keyId] },
        authToken: accessToken?.accessToken,
      });
    };
    fetchGames();
  }, [])


  if (!gameDetails) {
    return <div className="d-flex align-items-center justify-content-center" style={{ height: '75vh' }}>
      < HashLoader color="#e48181" />
    </div>
  }

  function formatCustomDate(dateStr) {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    let [datePart, timePart] = dateStr.split(" ");
    let [day, month, year] = datePart.split("-").map(Number);
    let [hours, minutes] = timePart.split(":").map(Number);

    let date = new Date(year, month - 1, day, hours, minutes);

    date.setDate(date.getDate() - 2);

    let newDay = date.getDate();
    let newMonth = months[date.getMonth()];
    let timeRange = "7-9 AM"; // Fixed time range

    return `${newDay} ${newMonth}, ${timeRange}`;
  }

  const gameInfo = [
    { icon: <MdPeopleOutline style={{ color: "#006FFD" }} />, text: `${gameDetails.currentPlayers} out of ${gameDetails.requiredPlayers} players` },
    { icon: <CiLocationArrow1 style={{ color: "#006FFD" }} />, text: gameDetails.courtName },
    { icon: <CiCalendarDate style={{ color: "#006FFD" }} />, text: `${formatCustomDate(gameDetails.startTime)}` },
    { icon: <FaDollarSign style={{ color: "#006FFD" }} />, text: `$${gameDetails.courtPrice} per player` },
  ];

  const aboutGameInfo = [
    { title: "Court Name", subTitle: gameDetails.courtName },
    { title: "Game Host", subTitle: gameDetails.hostName },
    { title: "Description", subTitle: gameDetails.details },
  ];


  const onGoToBackPage = () => {
    navigate(-1);
  }

  const handleCourtSelectFromMap = (court) => {
    setFormData((prev) => ({
      ...prev,
      courtName: court?.courtName
    }));

    if (errors?.courtName) {
      setErrors({
        ...errors,
        courtName: ""
      });
    }
  };


  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  if (!isModalVisible) return null;


  const isUserInGame = gameDetails?.participants?.some(
    (participant) => {
      return participant.userId === userId;
    }
  );

  const onHanldeAcceptOrReject = async (action) => {
    try {
      const result = await apiHandler({
        url: `${endpoint.GAME_INVITATION}?action=${action}`,
        method: "POST",
        authToken: accessToken?.accessToken,
        data: {
          gameId: gameId,
          transactionId: null,
          paymentIntentId: null
        },
      });

      if (result?.data?.message) {
        toast.success(result?.data?.message);
        navigate(-1);
      } else {
        toast.error("Failed to send invitation response");
      }
    } catch (error) {
      console.error("Error processing invitation:", error);
      toast.error("An error occurred");
    }

  };

  const leaveGameFunc = () => {
    setLeaveGame(true)
  }

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  return (
    <div className="container p-3 p-sm-0">
      <div className="d-flex justify-content-start mt-sm-4" >
        <CustomButton
          className="back-page-btn"
          onClick={onGoToBackPage}
          buttonText={
            <> <IoIosArrowDropleft className="me-3" style={{ cursor: 'pointer', fontSize: '31px' }} /> Back</>
          }
        />
      </div>
      <div className="row mt-sm-3 mb-sm-3">
        <div className="col-lg-6 notification-info-txt-wrapper" >
          <div className="d-flex justify-content-between py-2">
            <div className="game-txt fs-4" style={{ fontWeight: '600' }}>
              <img src={ballImage} width="30px" height="30px" className="me-3" alt="Game" />
              {gameDetails.gameName}
            </div>
            <div className="single-txt">{gameDetails.singularity}</div>
          </div>
          <div className="d-flex justify-content-between mt-3">
            <CustomButton buttonText={gameDetails?.level} className="custom-beginer-button text-upper" />
            <CustomButton buttonText={gameDetails?.sportName?.toUpperCase()} className="custom-beginer-button text-upper" />
          </div>
          <div className="mt-3">
            <span className={`approve-circle-${gameDetails?.status?.toLowerCase()}`}></span>
            <span className="active-txt">{gameDetails?.status}</span>
          </div>
          <div className="container py-4">
            <div className="game-info-txt fs-5" style={{ color: '#71727A' }}>Game Information</div>
            <div className="row mt-3">
              {gameInfo?.map((item, index) => (
                <div className=" col-6 col-sm-6 col-md-6" key={index}>
                  <div className="d-flex align-items-center p-1">
                    <div className="mr-2">{item.icon}</div>
                    <div className="approve-or-deny-game-info-txt">{item.text}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="row">
            {aboutGameInfo?.map((item, index) => (
              <div className={`col-6 col-sm-6 col-lg-6 col-md-6  ${aboutGameInfo.length === 1 || (aboutGameInfo.length % 2 !== 0 && index === aboutGameInfo.length - 1) ? "col-lg-12" : ""} `} key={index}>
                <div className="">
                  <h3 className="approve-or-deny-title">{item.title}</h3>
                  <p className="approve-or-deny-subtitle ">{item.subTitle}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="col-lg-6">
          <div className="mt-3 mt-sm-0" style={{ boxShadow: 'rgba(96, 97, 112, 0.16) 0px 2px 4px 0px', borderRadius: '10px', background: 'white' }}>
            <GoogleMapComponent height={'300px'} courtData={courtData} onCourtSelect={handleCourtSelectFromMap} />
          </div>
          <div>
            <div className="border p-2 p-sm-3 mt-3" style={{ boxShadow: 'rgba(96, 97, 112, 0.16) 0px 2px 4px 0px', borderRadius: '10px', background: 'white' }}>
              <div className="ps-2">
                <span className="approve-or-deny-game-info-txt">Participant</span>: {gameDetails.currentPlayers} Out of {gameDetails.requiredPlayers}
              </div>
              <div className="row">
                {gameDetails?.participants?.map((item, index) => (
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12  d-flex align-items-center justify-content-between px-0 px-sm-3 mb-2 mb-sm-0" key={index}>
                    <div className="d-flex align-items-center p-1 p-sm-3">
                      <img src={item.avatarUrl || participantImage} alt={item.name} className="border border-dark rounded-0" width="50" height="50" />
                      <div style={{ height: '66px', marginLeft: '10px', width: '10px', backgroundColor: '#e9ecef', borderRadius: '0px', overflow: 'hidden' }}>
                        <div
                          style={{
                            height: `${item?.reliability}%`,
                            width: '100%',
                            backgroundColor: 'green',
                            transition: 'height 0.3s ease',
                          }}
                        ></div>
                      </div>
                      <div className="d-sm-flex justify-content-between">
                        <div className="d-flex">
                          <div className="ml-3">
                            <strong className="text-primary px-2">{item.name}</strong>
                          </div>
                          <div>{gameDetails?.hostName?.toLowerCase() == item?.name?.toLowerCase() ? '(Host)' : ""}</div>
                        </div>
                        <div className="d-flex ms-2 ms-sm-0 mt-2 mt-sm-0">
                          <img src={item?.gender == "MALE" ? Boy : Girl} width='20px' height='20px' className="me-1" />
                          <div className="skill-level">{item?.skillLevel && `(${item?.skillLevel})`}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div>
                {console.log('gameDetails', gameDetails)}
                {gameDetails?.invitations?.length > 0 && gameDetails?.invitations[0]?.applied == false ?
                  <div className="pb-3 d-flex">
                    {saveCardDetailData?.userConfgis?.isEligibleForService ? (
                      <>
                        {profileData.baseProfile.avatarName !== gameDetails.hostAvatarName && (
                          <>
                            <CustomButton
                              buttonText={"Accept"}
                              className="border"
                              style={{
                                width: "100px",
                                height: "48px",
                                borderRadius: "12px",
                                background: "#006FFD",
                                color: "#FFFFFF",
                                marginRight: "15px",
                              }}
                              onClick={() => onHanldeAcceptOrReject(true)}
                            />

                            <CustomButton
                              buttonText={"Reject"}
                              className="border"
                              style={{
                                width: "100px",
                                height: "48px",
                                borderRadius: "12px",
                                background: "#006FFD",
                                color: "#FFFFFF",
                              }}
                              onClick={() => onHanldeAcceptOrReject(false)}
                            />
                          </>
                        )}
                      </>
                    ) : (
                      <div>
                        <div
                          className={`modal-overlay ${isOpen ? "open" : "closeModal"}`}
                          style={{ width: "100%", height: "500px" }}
                        >
                          <div className="modal-content">
                            <button onClick={toggleModal} className="close-button">
                              <RxCross2 className="fs-4" />
                            </button>
                            <PaymentModal PaymentWay={"notification"} gameId={gameId} />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  :
                  <div className="pb-3">
                    <CustomButton
                      buttonText={"Leave a Game"}
                      className="border"
                      disabled={!isUserInGame}
                      style={{
                        width: "400px",
                        height: "48px",
                        borderRadius: "12px",
                        background: '#FF616D',
                        color: "#FFFFFF",
                      }}
                      onClick={leaveGameFunc}
                    />

                  </div>

                }
              </div>
              {leaveGame && <LeaveGameModal onClose={handleCloseModal} filteredData={gameDetails} />}
              {isOpen && (
                <div className="modal-overlay open">
                  <div className="modal-content" style={{ width: "100%", overflow: 'auto' }}>
                    <button onClick={toggleModal} className="close-button">
                      <RxCross2 className="fs-4" />
                    </button>
                    <PaymentModal PaymentWay={"joinedGame"} gameId={selectedGameId} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameDetails;
